<template>
  <div
    class="lg:px-5 md:px-2.5 px-0 md:bg-transparent bg-white sm:py-5 md:py-2.5 py-0 max-w-7xl mx-auto"
  >
    <BaseTopNav
      :nav-class="
        y > 200 ? '' : 'shadow-xs shadow-xl border-b border-b-gray-100'
      "
    >
      <template #center>
        <p class="whitespace-nowrap">{{ $t("nav.links.artist_profile") }}</p>
      </template>
      <template #right>
        <span></span>
      </template>
    </BaseTopNav>

    <ArtistDetails>
      <template #artist-gallery>
        <ArtworkGallery
          :not-found-title="$t('not_found.artworks.title')"
          :items="gallery.artworks"
          :loading="gallery.artworksFetching || gallery.filtering || loading"
          :total-pages="gallery.meta?.totalPages"
          :current-page="gallery.page"
          @change-page="gallery.changePage"
          @next="gallery.nextPage"
          @prev="gallery.prevPage"
      /></template>
    </ArtistDetails>
  </div>
</template>

<script setup lang="ts">
import { useArtistGalleryStore } from "~/stores/artist.gallery";
import { useWindowScroll } from "@vueuse/core";

const { y } = useWindowScroll();
const route = useRoute();
const gallery = useArtistGalleryStore();

const loading = ref<boolean>(true);

onMounted(async () => {
  const id = route.params.id as string;
  if (!id) return;
  await gallery.initArtistGallery(id);
  loading.value = false;
});
</script>
